import React, { useEffect, useState } from 'react';
import { jwtDecode } from 'jwt-decode'; 
// import logoImg from '../assets/img/logo.png';
import logoImg from '../assets/img/red-logo.png';
import UserLogImg from '../assets/img/userimg.png';
import UserImg from '../assets/img/user-img.png';
import startImg from '../assets/img/star.svg';
// import startImg from '../assets/img/star.svg';

import { Search, } from "lucide-react";

import '../../src/assets/css/style.css';
import { Link, useNavigate, NavLink } from "react-router-dom";
import NotificationToggle from './NotificationToggle';

const Header = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [showWarning, setShowWarning] = useState(false);
  const [userProfilesBox, setUserProfilesBox] = useState(false);
  const [coinsPopupbBox, setCoinsPopupBox] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navigate = useNavigate();

  const userProfileOpen = (e) => {
    e.stopPropagation();
    setUserProfilesBox(!userProfilesBox);
     setCoinsPopupBox(false);
  };

  const coinsPopupOpen = (e) => {
     e.stopPropagation();
     setCoinsPopupBox(!coinsPopupbBox);
     setUserProfilesBox(false);
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen((prev) => !prev);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  useEffect(() => {
    const handleClick = () => {
      setUserProfilesBox(false);
      setCoinsPopupBox(false);
    };
    
    // const handleClick = () => setUserProfilesBox(false);


    window.addEventListener("click", handleClick);
    return () => window.removeEventListener("click", handleClick);
  }, []);    

   useEffect(() => {
    const checkLoginStatus = () => {
      const token = localStorage.getItem('token');
      const user = localStorage.getItem('user');
      if (token && user) {
        try {
          const decoded = jwtDecode(token);
          const currentTime = Date.now() / 1000;
          if (decoded.exp && decoded.exp > currentTime) {
            setIsLoggedIn(true);
            const parsedUser = JSON.parse(user);
            setFirstName(parsedUser.first_name || '');
            setLastName(parsedUser.last_name || '');
            const timeLeftMs = (decoded.exp - currentTime) * 1000;
            const logoutTimer = setTimeout(() => {
              handleLogout();
            }, timeLeftMs);
            const warningTimer = setTimeout(() => {
              setShowWarning(true);
            }, timeLeftMs - 300000); // 5 minutes before expiry
            return () => {
              clearTimeout(logoutTimer);
              clearTimeout(warningTimer);
            };
          } else {
            handleLogout();
          }
        } catch (error) {
          console.error('Invalid token:', error);
          handleLogout();
        }
      } else {
        setIsLoggedIn(false);
      }
    };
    // Initial check
    checkLoginStatus();
    // Listen to localStorage changes (e.g. after login)
    window.addEventListener("storage", checkLoginStatus);
    return () => {
      window.removeEventListener("storage", checkLoginStatus);
    };

  }, []);



  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setIsLoggedIn(false);
    setMobileMenuOpen(false);
    navigate('/login');
  };

  return (
    <header className="header">
      <div className="container-fluid px-lg-5">
        <div className="row align-items-center py-1 innerheaderbox">
          <div className="col-lg-3 col-md-4 col-6 logonamebox">
            <a href="/" className="cnamelogo"><img src={logoImg} alt="Logo" /> <span>Industry & People</span> </a>
          </div>

          <div className="col-lg-5 col-6 mainmenubox">
            <nav className="navbar navbar-expand-lg justify-content-end">
              <button
                className="navbar-toggler"
                type="button"
                onClick={toggleMobileMenu}
                aria-controls="navbarSupportedContent"
                aria-expanded={mobileMenuOpen}
                aria-label="Toggle navigation"
              >
                <span className="navbar-toggler-icon"></span>
              </button>
              <div
                className={`collapse navbar-collapse ${mobileMenuOpen ? 'show' : ''}`}
                id="navbarSupportedContent"
              >
                <button
                  type="button"
                  id="close_mobile_nav"
                  className="ft-24 btn-link text-dark p-0 d-lg-none"
                  onClick={closeMobileMenu}
                  aria-label="Close menu"
                >
                  <i className="bi bi-x-lg"></i>
                </button>
                <ul className="navbar-nav gap-4 mx-auto">
                  <li className="nav-item">
                    <NavLink to="/" className="nav-link" onClick={closeMobileMenu}>Home</NavLink>
                    
                  </li>
                  <li className="nav-item">
                    <NavLink to="/about" className="nav-link" onClick={closeMobileMenu}>About</NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink to="/Dashboard" className="nav-link" onClick={closeMobileMenu}>Create Survey</NavLink>
                  </li>
                  {/* <li className="nav-item">
                    <NavLink to="/Survey" className="nav-link">Create Survey</NavLink>
                  </li> */}
                   <li className="nav-item">
                    <NavLink to="/contactus" className="nav-link" onClick={closeMobileMenu}>Contact Us</NavLink>
                  </li>

                  {/* <li className="nav-item">
                    <NavLink to="/search" className="nav-link">Search Connection</NavLink>
                  </li> */}
                </ul>

                <div className="d-lg-none mt-4">
                  {isLoggedIn ? (
                    <div className="d-flex flex-column gap-3">
                      <Link to="/myprofile" className="nav-link px-0" onClick={closeMobileMenu}>
                        My Profile
                      </Link>
                      <button className="btn loginbtn ft-15 fw-600" onClick={handleLogout}>
                        Logout
                      </button>
                    </div>
                  ) : (
                    <div className="d-flex flex-column gap-3">
                      <Link to="/PreSignup" className="inter whitered" onClick={closeMobileMenu}>
                        Sign Up
                      </Link>
                      <Link to="/login" className="btn loginbtn ft-15 fw-600" onClick={closeMobileMenu}>
                        Log In
                      </Link>
                    </div>
                  )}
                </div>
              </div>
            </nav>
          </div>

          <div className="d-none d-lg-block col-lg-4 loginprofilebox"> 
            {isLoggedIn ? (
              <div className="d-flex right-menu-top ft-15 align-items-center justify-content-end gap-4">
                {/* <Link to="/search" className="search_icon">
                  <i className="bi bi-search ft-20" style={{ color: "#000" }}></i>
                </Link> */}

                <div style={{position:'relative'}}>
                  <div className="totalpoints me-3" onClick={coinsPopupOpen} >
                    <img src={startImg} alt="" /> <span>50</span>
                  </div>

                  {coinsPopupbBox && (
                    <div className={`userprofilesbox ${coinsPopupbBox ? "coinspopupbox" : ""}`}  onClick={(e) => e.stopPropagation()}>
                      <div className="sidebar-content text-center"> 

                        <img src={startImg} alt="" className="coinimg mb-4" />

                        <p className="earnedcoin ft-18 fw-400 lh-20 mb-4">I & P Coins earned!</p>    

                        <div className="samplecoines d-flex gap-4 rounded-3 p-3 mb-4">
                          <div className="ft-15 fw-500">You earned</div> 
                          <div className="d-flex gap-2 ft-15 fw-500"> <img src={startImg} alt="" /> <span>50 star points</span></div>
                        </div>

                        <p className="mb-5">Redeem your coins on your next purchase and save!</p>   

                        <div className="create_survey_button_box d-flex justify-content-end align-items-center">
                          <div className="d-flex gap-3">
                              <Link
                                to="javascript:void(0);"
                                className="btn btn-outline-dark text-decoration-none preview_survey rounded-3 ft-15 d-flex justify-content-center align-items-center"
                              >
                               Redeem Now
                              </Link>
                              <Link
                                to="javascript:void(0);"
                                className="btn btn-red text-decoration-none create_survey rounded-3 ft-15"
                              >
                                Buy Now
                              </Link>
                          </div>
                        </div>  

                      </div>
                    </div>
                  )}
                </div>


              <div style={{position:'relative'}}>
                <Link onClick={userProfileOpen} className="userimgname d-flex align-items-center gap-1 text-black">
                  <img src={UserLogImg} className="rounded-50" alt="User" />
                  <div>{firstName} {lastName}</div>
                </Link>

              {userProfilesBox && (
                  <div className={`userprofilesbox ${userProfilesBox ? "active" : ""}`}  onClick={(e) => e.stopPropagation()}>
                    <div className="sidebar-content"> 
                      <div className="user-info d-flex align-items-center gap-2 mb-3 border-1">
                        <img src={UserImg} alt="User" className="user-avatar"/>
                        <div className="user-text">
                          <p className="mb-0 fw-bold">Esther Howard</p>
                          <p className="mb-0 text-muted">yourname@gmail.com</p>
                        </div>
                      </div>
                      <ul>
                        <li><Link to="/myprofile" className="active"><i className="bi bi-person-circle"></i> <span>My Profile</span></Link></li>
                        <li>                          
                          <Link href="javascript:void(0)"><i className="bi bi-bell"></i>                           
                              <NotificationToggle label="Notifications"/>
                          </Link>
                          </li>
                        <li><Link href="javascript:void(0)"><i className="bi bi-clipboard-check"></i> <span> Survey</span></Link></li>
                        <li><Link href="javascript:void(0)"><i className="bi bi-wallet2"></i> <span> Wallet</span></Link></li>
                        <li><Link href="javascript:void(0)"><i className="bi bi-question-circle"></i> <span> Help & Support</span></Link></li>
                        <li><button className="logoutbtn" onClick={handleLogout}><i className="bi bi-box-arrow-right"></i> Logout</button></li>
                      </ul>
                    </div>
                  </div>
              )}
              </div>

                {/* <button className="btn btn-red ft-15 fw-600 ms-3" onClick={handleLogout}>Logout</button> */}
              </div>
            ) : (
              <div className="d-flex right-menu-top ft-15 align-items-center justify-content-end gap-4">                

               <div className="search-box d-flex align-items-center justify-content-between gap-3">
                  <input
                    type="text"
                    placeholder="Find People & Companies..."
                    className="search-input border-0 bg-transparent w-100"
                  />

                  <button className="search-btn border-0 bg-transparent">
                    <Search size={20} />
                  </button>
                </div>


                <Link to="/PreSignup" className="inter whitered">Sign Up</Link>
                <Link to="/login" className="btn loginbtn ft-15 fw-600">Log In</Link>
              </div>
            )}
          </div>
        </div>
        {showWarning && (
          <div className="alert alert-warning text-center mt-2" role="alert">
            Your session expired. Login!
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
